<template>
  <div class="featured-article-videos" v-if="featuredArticleVideos.length > 0">
    <div class="featured-article-videos__heading">
      <h1>VIDEOS</h1>
      <hr class="divider">
    </div>
    <div class="featured-article-videos__list container">
      <ArticleVideoBlockComponent
        v-for="video in featuredArticleVideos"
        :key="video.slug"
        :video="video"
      />
    </div>
    <div class="featured-article-videos__footer">
      <a
        class="featured-videos__link"
        :href="articleVideosUrl"
      >
        <span> {{ $t("buttons.view-more-videos") }} </span>
      </a>
    </div>
  </div>
</template>

<script>
import ArticleVideoBlockComponent from '../article_video/ArticleVideoBlockComponent.vue';
import gql from 'graphql-tag';

export default {
  name: 'ArticleVideosComponent',

  components: {
    ArticleVideoBlockComponent,
  },

  props: {
    articleVideosUrl: {
      type: String,
      default: '#',
    },
    country: {
      type: String,
      default: 'SG',
    },
    locale: {
      type: String,
      default: 'en',
    },
  },
  
  apollo: {
    featuredArticleVideos: {
      query: gql` query featuredArticleVideos($country: String!, $locale: String!){
        featuredArticleVideos(country: $country, locale: $locale){
          id
          title
          subtitle
          featuredImage
          duration
          publishedAt
          formattedViews
          url
        }
      }`,
      variables(){
        return {
          country: this.country,
          locale: this.locale,
        }
      }
    }
  },
  data() {
    return {
      featuredArticleVideos: []
    }
  }
};
</script>
